import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Comment } from 'src/app/models/comment.model';
import { trackById } from 'src/app/shared/utils/track-by.util';

export type ChartAnnotationPopupMode = 'single' | 'list';

@Component({
  standalone: false,
  selector: 'app-chart-annotation-popup',
  templateUrl: './chart-annotation-popup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./chart-annotation-popup.component.scss'],
})
export class ChartAnnotationPopupComponent {
  @Input() mode: ChartAnnotationPopupMode = 'single';
  @Input() comment: Comment | null = null;
  @Input() comments: Comment[] = [];

  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<Comment>();
  @Output() deleted = new EventEmitter<Comment>();
  @Output() commentSelected = new EventEmitter<Comment>();

  isEditing = false;
  editText = '';

  readonly trackByCommentId = trackById;

  startEdit(): void {
    this.editText = this.comment?.text ?? '';
    this.isEditing = true;
  }

  cancelEdit(): void {
    this.isEditing = false;
  }

  saveEdit(): void {
    if (!this.comment || !this.editText?.length) {
      return;
    }
    this.saved.emit({ ...this.comment, text: this.editText });
    this.isEditing = false;
  }

  deleteComment(): void {
    if (!this.comment) {
      return;
    }
    this.deleted.emit(this.comment);
  }

  selectComment(comment: Comment): void {
    this.commentSelected.emit(comment);
  }

  close(): void {
    this.closed.emit();
  }
}
